<template>
  <div class="kioskct">
    <div id="kctfn">
      <div id="kfinance" class="kcttt">Financial</div>
      <div class="kctmenu">
        <div v-for="item,index in mdata" :class="index==findex?'kctmsl':''" :key="item.label" @click="findex=index"><label>{{item.label}}</label></div>
      </div>
      <div class="kctpg">
        <h5>{{mdata[findex].p1}}</h5>
        <div v-if="mdata[findex].advantage" class="kctptt">Advantages:</div>
        <div v-if="mdata[findex].advantage" class="kadv">{{mdata[findex].advantage}}</div>
        <div class="kctptt">Standard Configuration:</div>
        <div class="kconfig">
          <div v-for="item,index in mdata[findex].config" :key="item">{{index+1}}.{{item}}</div>
        </div>
        <div class="kctptt">Customized options:</div>
        <div class="koption">
          <div v-for="item in mdata[findex].option" :key="item">
            <img :src="require('@/assets/pic/kiosk/check.png')" /><label>{{item}}</label>
          </div>
        </div>
        <div class="kalbum">
          <img @click="swcPic(0,0)" :class="mdata[findex].pics.length<3?'khide':''" :src="require('@/assets/pic/kiosk/left.png')" />
          <img v-if="mdata[findex].pics.length>0" :src="mdata[findex].pics[0]" />
          <img v-if="mdata[findex].pics.length>1" :src="mdata[findex].pics[1]" />
          <img v-if="mdata[findex].pics.length>2" :src="mdata[findex].pics[2]" />
          <img @click="swcPic(0,1)" v-if="mdata[findex].pics.length>2" :src="require('@/assets/pic/kiosk/right.png')" />
        </div>

      </div>
    </div>
    <div id="kctnfn">
      <div class="kcttt">Non-Financial</div>
      <div class="kctmenu" id="knfinance">
        <div v-for="item,index in mdata1" :class="index==nindex?'kctmsl':''" :key="item.label" @click="nindex=index"><label>{{item.label}}</label></div>
      </div>
      <div class="kctpg" >
        <h5>{{mdata1[nindex].p1}}</h5>
        <div v-if="mdata1[nindex].advantage" class="kctptt">Advantages:</div>
        <div v-if="mdata1[nindex].advantage" class="kadv">{{mdata1[nindex].advantage}}</div>
        <div class="kctptt">Standard Configuration:</div>
        <div class="kconfig">
          <div v-for="item,index in mdata[findex].config" :key="item">{{index+1}}.{{item}}</div>
        </div>
        <div class="kctptt">Customized options:</div>
        <div class="koption">
          <div v-for="item in mdata[findex].option" :key="item">
            <img :src="require('@/assets/pic/kiosk/check.png')" /><label>{{item}}</label>
          </div>
        </div>
         <div class="kalbum">
          <img @click="swcPic(1,0)" :class="mdata1[nindex].pics.length<3?'khide':''"  :src="require('@/assets/pic/kiosk/left.png')" />
          <img v-if="mdata1[nindex].pics.length>0" :src="mdata1[nindex].pics[0]" />
          <img v-if="mdata1[nindex].pics.length>1" :src="mdata1[nindex].pics[1]" />
          <img v-if="mdata1[nindex].pics.length>2" :src="mdata1[nindex].pics[2]" />
          <img @click="swcPic(1,1)" v-if="mdata1[nindex].pics.length>2" :src="require('@/assets/pic/kiosk/right.png')" />
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    data: Object
  },
  watch: {
  
  },
  data () {
    return {
      findex: 0,
      nindex: 0,
      mdata: [
        {
          label: 'Bill Payment Kiosks', 
          p1: "As a turbulent economy spurs companies to seek ways to control costs, many are looking at their payment collection systems for ways to be more efficient. And for some, those efficiencies can be obtained via the use of bill payment kiosks. SZZT bill payment kiosks are not only compact and attractive; they are solidly built to last for dependable, worry-free performance. Their real beauty quietly operates behind the scene. This is the most advanced financial processing system available, loaded with the latest security features. Customers will get all the high-level security of a bank or lockbox in an intuitive, automated system that's easy to use-for customers and their customers.",
          config: [
            'Processor: Industrial Motherboard: Intel Dual-core CPU,500G HDD/SSD ;','LCD Touch Monitor: 15”,17”,19”LCD TFT or higher Security PINPAD : PCI EPP/Encrypted ',
            'PINPAD or Keyboard Card reader: Reading Magnetic /IC/Chip/RFID Card',
            'Cash Acceptor: Accepting rich banknotes, with cash box in 600-2000 notes',
            'Cash dispenser: in multi-cassettes 1, 2, 3, 4 optional Coin dispenser/hopper/sorter: For changes',
            'Printing methods: Thermal/Dot-matrix Receipt Printer WIFI/3G/LAN',
            'UPS'
          ],
          option: [
            'Kiosk Cabinet: Sheet steel, or stainless steel body and base',
            'Customized color & LOGO',
            'Surface processing',
            'Standard Configuration or Optional Components',
          ],
          pics: [
            require('@/assets/pic/kiosk/bill.jpg'),
            require('@/assets/pic/kiosk/bill1.jpg'),
          ]
        },
        {
          label: 'Financial Kiosk', 
          p1: 'This kind of kiosk solution enables consumers to independently stage money transfer and electronic payment transactions using a highly secure & reliable platform. The platform is designed to deliver high volume financial services in retail stores, banks, and post offices. Besides, they are very sophisticated and are equipped with numerous peripherals such as card readers, passport readers, and barcode scanners used for reading various state and country issued IDs.',
          config: [
            'Processor: Industrial Motherboard: Intel Dual-core CPU,500G HDD/SSD ;',
            'LCD Touch Monitor: 15”,17”,19”LCD  TFT or higher Security PINPAD : PCI  EPP/Encrypted',
            'PINPAD or Keyboard Card reader: Reading Magnetic/IC/Chip/RFID Card Payment methods: Card Reader /Cash or Coin Accepter/Disperser mode',
            'Printing methods: Thermal/Dot-matrix Receipt Printer WIFI/3G/LAN',
            'UPS'
          ],
          option: [
            'Kiosk Cabinet: Sheet steel, or stainless Steel body and base',
            'Rich Color and customer’s LOGO •Surface processing',
            'Standard Configuration or Optional Components'
          ],
          pics: [
            require('@/assets/pic/kiosk/fn.jpg'),
          ]
        },
        {
          label: 'Digital Signage Kiosk', 
          p1: "An elegant flexible digital information display to deliver dynamic visual messages experience with 42” HD LCD large screen application which for advertisement, the ultra slim, upright tower design is perfect for a variety of digital signage uses. The free standing tower allows convenient placement anywhere electricity is available.",
          config: [
            'Processor: Industrial Motherboard: Intel Dual-core CPU, 500G HDD/SSD;',
            'LCD Display: 21.5”, 42”, 64” LCD or better- HD ready',
            'Receipt Printing: Thermal receipt/ticket/printer',
            'Stereo sound media player support WIFI/3G/Ethernet (10/100/1000)'
          ],
          option: [
            'Kiosk Cabinet: Sheet steel, or stainless steel body and base ',
            'Customized color & LOGO',
            'Surface processing',
            'Standard Configuration or Optional Components'
          ],
          advantage: '7x24 hours running; Save labor cost and employee time of your organization User-friendly; easy to operation with stereo sound media in high visual dynamic experience.',
          pics: [
            require('@/assets/pic/kiosk/digital.jpg'),
            require('@/assets/pic/kiosk/digital1.jpg'),
            require('@/assets/pic/kiosk/digital2.jpg'),
          ]
        },
      ],
      mdata1: [
        {
          label: 'Check-in Kiosk', 
          p1: "Check-in Kiosks have become increasingly common in a variety of different environments in recent years. Generally, the most familiar check in kiosks are the ones at the airport, hotel, hospital, etc. The automated services these kiosks provide help keep lines shorter and time flow more efficiently.  Checking in at the kiosk typically takes only a fraction of the time normally involved to check in with an attendant. These kinds of kiosks are very sophisticated and are equipped with numerous peripherals such as card readers, passport readers, and barcode scanners used for reading various state and country issued IDs.",
          config: [
            'Processor: Industrial Motherboard: Intel Dual-core CPU, 500G HDD/SSD;',
            'LCD Touch Monitor: 15”,17”,19” LCD TFT or higher Security PINPAD : PCI EPP/Encrypted PINPD or Keyboard',
            'Card reader: Reading Magnetic /IC/Chip/RFID Card Passport /ID Reader ',
            'Cash Acceptor: Accepting rich banknotes, with cash box in 600-2000 notes ',
            'Tickets Printing: Boarding pass or receipting printing WIFI/3G/LAN UPS'
          ],
          option: [
            'Kiosk Cabinet: Sheet steel, or stainless steel body and base',
            'Customized color & LOGO',
            'Surface processing',
            'Standard Configuration or Optional Components'
          ],
          pics: [
            require('@/assets/pic/kiosk/check.jpg'),
          ]
        },
        {
          label: 'Information Inquiry Kiosk', 
          p1: "The sleek contemporary design of this information inquiry kiosk makes it the ideal self-service solution for most service industries. Our engineers thought of it all, this mighty kiosk can accommodate more standard and optional components than you can shake a stick at, all in a tidy enclosure. Configure the kiosk around your needs, around your brand by taking advantage of the generous graphic space. With its variety of hardware configurations, easy service access and large corporate customization space; it is a high achiever and remains a popular, cost effective solution.",
          config: [
            'Processor: Industrial Motherboard: Intel Dual-core CPU, 500G HDD/SSD; ',
            'LCD Touch Monitor: 15”, 17”, 19” LCD TFT or higher',
            'Security PINPAD: PCI EPP/Encrypted PINPAD or keyboard',
            'Receipt Printing: Thermal /ticket/Invoice printer',
            'WIFI/3G/LAN'
          ],
          option: [
            'Kiosk Cabinet: Sheet steel, or stainless steel body and base',
            'Customized color & LOGO',
            'Surface processing',
            'Standard Configuration or Optional Components'
          ],
          pics: [
            require('@/assets/pic/kiosk/info.jpg'),
            require('@/assets/pic/kiosk/info1.jpg'),
            require('@/assets/pic/kiosk/info2.jpg'),
          ]
        }
      ],

    }
  },
  methods: {
    swcPic (mdindex, isnext) {
      var tarr = mdindex==0?this.mdata[this.findex].pics:this.mdata1[this.nindex].pics
      if (isnext) {
        var obj = tarr.shift()
        tarr.push(obj)
      } else {
        var obj = tarr.pop()
        tarr.unshift(obj)
      }
    }
  },
  mounted () {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.kioskct {
  background: white;
  overflow: hidden;
  padding-top: .71rem;
  padding-bottom: 3.09rem;
}

.kcttt {
  font-size: .6rem;
  font-weight: bold;
  color: #1A1A1A;
  margin-top: .57rem;
  margin-bottom: .29rem;
}

#kctfn,#kctnfn {
  padding-left: 3.44rem;
  overflow: hidden;
}

#kctfn {
  min-height: 14.5rem;
  background: rgba(0, 128, 203, 0.06);
  padding-bottom: .67rem;
}

#kctnfn {
  min-height: 14.3rem;
  background: #F7F7F7;
  padding-bottom: .67rem;
}

.kctmenu, .kctpg {
  display: inline-block;
  vertical-align: top;
  /* border: 1px solid red; */
}

.kctpg h5 {
  width: 8.34rem;
  font-size: .18rem;
  font-weight: 400;
  color: #4D4D4D;
  margin: .5rem 0 .33rem .41rem;
}

.kctmsl label {
  font-weight: bold;
  padding-bottom: .11rem;
  border-bottom: 2px solid #F09323;
  border-radius: 1px;
}
.kctmenu {
  width: 3.03rem;
  padding-top: .25rem;
  font-size: .22rem;
  font-weight: 400;
  color: #333333;
}
.kctmenu div {
  margin-bottom: .43rem;
}
.kctmenu label {
  cursor: pointer;
}

.kctpg {
  width: 9.3rem;
  background: #FFFFFF;
  border-radius: 20px;
}

.kctptt {
  font-size: .3rem;
  font-weight: bold;
  color: #0080CB;
  margin-left: .41rem;
  margin-top: .4rem;
  margin-bottom: .28rem;
}

.kadv {
  font-size: .18rem;
  font-weight: 400;
  color: #4D4D4D;
  margin-left: .41rem;
}

.kconfig,.koption {
  margin-left: .41rem;
}
.kconfig div,.koption div {
  margin-bottom: .2rem;
}

.koption img {
  width: 18px;
  height: 18px;
  margin: 0 .07rem 0 0;
  vertical-align: middle;
}
.koption label {
  vertical-align: middle;
}

.kalbum {
  margin: .4rem 0 .44rem 0;
  position: relative;
  overflow: hidden;
  height: 2.6rem;
}
.khide {
  opacity: 0;
}

.kalbum img {
  position: absolute;
}
.kalbum img:nth-child(1) {
  width: .36rem;
  height: .36rem;
  left: .09rem;
  top: 1.11rem;
  cursor: pointer;
}
.kalbum img:nth-child(5) {
  width: .36rem;
  height: .36rem;
  right: .14rem;
  top: 1.11rem;
  cursor: pointer;
}
.kalbum img:nth-child(2) {
  width: 2.6rem;
  height: 2.6rem;
  left: .58rem;
}
.kalbum img:nth-child(3) {
  width: 2.6rem;
  height: 2.6rem;
  left: 3.35rem;
}
.kalbum img:nth-child(4) {
  width: 2.6rem;
  height: 2.6rem;
  right: .58rem;
}



</style>
